import requests from './request.js'
import requestscrm from "./requestscrm.js"

function getNavigationDat(data) {
	return requests('/ocNetSchool/getNavigationDat?schoolId=' + data, "POST", {})
}

function getSchoolInfo(data) {
	return requests('/ocNetSchool/getSchoolInfo?schoolId=' + data, "POST", {})
}

function search(data) {
	return requests('/ocNetSchool/search ', "POST", {
		...data
	})
}

function getLiveCourseUrl(data) {
	return requests(`/ocNetSchool/getLiveCourseUrl/${data}`, "POST", {})
}

function getLiveUrl(data) {
	return requests(`/ocNetSchool/getLiveUrl/${data}`, "POST", {})
}

function getCurriculumScheduleList(data) {
	return requests(`/ocNetSchool/getCurriculumScheduleList?month=${data}`, "POST", {})
}

function getCurriculumScheduleListByDay(data) {
	return requests(`/ocNetSchool/getCurriculumScheduleListByDay/${data}`, "POST", {})
}

function getCustomMenuDatDtoList(data) {
	return requests(`/ocNetSchool/getCustomMenuDatDtoList`, "POST", {})
}

function getSchoolCode() {
	return requests(`/ocNetSchool/getSchoolCode`, "POST", {})
}

function getmyliveHistory(page, pageSize) {
	return requests(`/MyLearnHistory/getmyliveHistory?page=${page}&pageSize=${pageSize}`, "POST", {})
}

function getmyyesterdayHistory(page, pageSize) {
	return requests(`/MyLearnHistory/getmyyesterdayHistory`, "POST", {})
}

function getPageByHomeId(homePageId) {
	return requests(`/ocNetSchool/getPageByHomeId?homePageId=${homePageId}`, "POST", {})
}

function getmylastHistory() {
	return requests(`/MyLearnHistory/getmylastHistory`, "POST", {})
}

function getAppidBySchool(schoolId) {
	return requests(`/ocNetSchool/getAppidBySchool?schoolId=${schoolId}`, "POST", {})
}

function getSmsCode(ticket, randomNumber, phone, sendType) {
	return requests(`/auth/getSmsCode`, "POST", {
		ticket, randomNumber, phone, sendType
	})
}

function loginBySchool(phone, phoneCode, schoolId, sendType) {
	return requests(`/auth/loginBySchool`, "POST", {
		phone, phoneCode, schoolId, sendType
	})
}

function resetPasswordBySchool(phone, phoneCode, schoolId, password) {
	return requests(`/auth/resetPasswordBySchool`, "POST", {
		phone, phoneCode, schoolId, password
	})
}

function accountLogin(uniqueCode, account, password) {
	return requests(`/auth/login?uniqueCode=${uniqueCode}&account=${account}&password=${password}`, "POST", {})
}

function verificationByRebind(phone,code) {
	return requests(`/auth/verificationByRebind`, "POST", { phone, code })
}

function getMyCourseHistory(page, pageSize) {
	return requests(`/MyLearnHistory/getMyCourseHistory?page=${page}&pageSize=${pageSize}`, "POST", {})
}

function verifyChannel(code) {
	return requests(`/channel/verifyChannel?code=${code}`, "POST", {})
}

function channelCode(channelId,schoolId,roomId,courseId) {
	return requests(`/channelShare/channelCode`, "POST", { channelId,schoolId,roomId,courseId })
}

function bindLiveWxUser(enterpriseCode,openId,unionId,subjectType) {
	return requestscrm(`/weLive/bindLiveWxUser`, "POST", { enterpriseCode,openId,unionId,subjectType })
}


export default{
	getNavigationDat,
	getSchoolInfo,
	search,
	getLiveCourseUrl,
	getLiveUrl,
	getCurriculumScheduleList,
	getCurriculumScheduleListByDay,
	getCustomMenuDatDtoList,
	getSchoolCode,
	getmyliveHistory,
	getmyyesterdayHistory,
	getPageByHomeId,
	getmylastHistory,
	getAppidBySchool,
	getSmsCode,
	loginBySchool,
	resetPasswordBySchool,
	accountLogin,
	verificationByRebind,
	getMyCourseHistory,
	verifyChannel,
	channelCode,
	bindLiveWxUser,
}